// Curated list of popular Google Fonts for the site-wide font picker.
// No API key required — loaded via the Google Fonts CSS endpoint.
export const GOOGLE_FONTS = [
  "Poppins",
  "Inter",
  "Roboto",
  "Open Sans",
  "Lato",
  "Montserrat",
  "Nunito",
  "Nunito Sans",
  "Raleway",
  "Work Sans",
  "Rubik",
  "DM Sans",
  "Manrope",
  "Plus Jakarta Sans",
  "Mulish",
  "Quicksand",
  "Josefin Sans",
  "Playfair Display",
  "Merriweather",
  "Lora",
  "PT Serif",
  "Source Sans 3",
  "Figtree",
  "Space Grotesk",
  "Outfit",
];

// Serif families render better with a serif fallback.
const SERIF = new Set(["Playfair Display", "Merriweather", "Lora", "PT Serif"]);

export function fontStack(family) {
  if (!family) return null;
  const fallback = SERIF.has(family) ? "Georgia, serif" : "system-ui, -apple-system, sans-serif";
  return `'${family}', ${fallback}`;
}

export function googleFontHref(family) {
  if (!family) return null;
  const spec = family.trim().replace(/\s+/g, "+");
  return `https://fonts.googleapis.com/css2?family=${spec}:wght@300;400;500;600;700;800&display=swap`;
}
